import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useI18n } from "../../i18n/I18nContext";
import { api } from "../../lib/api";

export default function Policies() {
  const { key } = useParams();
  const { isAr } = useI18n();
  const [policies, setPolicies] = useState([]);
  useEffect(() => { api.get("/policies").then((r) => setPolicies(r.data)).catch(() => {}); }, []);
  const shown = key ? policies.filter((p) => p.key === key) : policies;
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-8">
      {shown.map((p) => (
        <div key={p.id} className="mb-10">
          <h1 className="text-2xl font-bold text-slate-900 sm:text-3xl">{isAr ? p.title_ar : p.title_en}</h1>
          <p className="mt-4 leading-relaxed text-slate-600">{isAr ? p.body_ar : p.body_en}</p>
        </div>
      ))}
    </div>
  );
}
